import { render } from "./WelcomeForfettario.vue?vue&type=template&id=90ecbdbe&scoped=true&ts=true"
import script from "./WelcomeForfettario.vue?vue&type=script&lang=ts"
export * from "./WelcomeForfettario.vue?vue&type=script&lang=ts"

import "./WelcomeForfettario.vue?vue&type=style&index=0&id=90ecbdbe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90ecbdbe"]])

export default __exports__